var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"admin_panel__dashboard__menu__item",on:{"click":_vm.toName}},[_vm._v(" "+_vm._s(_vm.item.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }